export function getNextMonthFirstDateFormatted() {
  return new Date(
    new Date().getFullYear(),
    new Date().getMonth() + 1,
    1
  ).toLocaleDateString("en-US");
}
